module.exports = __webpack_public_path__ + "img/T618.d928edaf.jpg";